import {
  Cpu,
  Smartphone,
  Laptop,
  Monitor,
  Tablet,
  Glasses,
  Gamepad2,
  Server,
  Package,
  CircuitBoard,
  MemoryStick,
  Box,
  HardDrive,
  Zap,
  Apple,
  Joystick,
  Headphones,
  Keyboard,
  Briefcase,
  Tv,
  Wrench,
  Fan,
} from 'lucide-react';

/**
 * Maps category IDs → Lucide icon components.
 *
 * Top-level categories get a broad icon; subcategories get something
 * more specific where a good match exists, falling back to the parent.
 */
const CATEGORY_ICONS = {
  // ── Top-level ──────────────────────────────
  'pcs-and-parts': Cpu,
  phones: Smartphone,
  laptops: Laptop,
  'pre-built-desktops': Monitor,
  tablets: Tablet,
  vr: Glasses,
  consoles: Gamepad2,
  'ai-and-data-centre': Server,
  others: Package,

  // ── PC Parts subcategories ─────────────────
  cpu: Cpu,
  gpu: CircuitBoard,
  ram: MemoryStick,
  cases: Box,
  motherboards: CircuitBoard,
  storage: HardDrive,
  psu: Zap,
  cooling: Fan,

  // ── Phone subcategories ────────────────────
  'phones-iphone': Apple,
  'phones-android': Smartphone,
  'phones-other': Smartphone,
  'phone-parts': Wrench,

  // ── Laptop subcategories ───────────────────
  'laptops-apple-macbooks': Apple,
  'laptops-windows-laptops': Laptop,
  'laptops-linux-laptops': Laptop,
  'laptops-other-laptops': Laptop,
  'laptop-parts': Wrench,

  // ── Desktop subcategories ──────────────────
  'pre-built-desktops-apple-mac': Apple,
  'pre-built-desktops-windows-desktops': Monitor,
  'pre-built-desktops-linux-desktops': Monitor,
  'pre-built-desktops-gaming-pc': Gamepad2,
  'pre-built-desktops-custom-pc': Cpu,
  'pre-built-desktops-other': Monitor,

  // ── Tablet subcategories ───────────────────
  'tablets-apple-ipads': Apple,
  'tablets-android-tablets': Tablet,
  'tablets-other': Tablet,
  'tablet-parts': Wrench,

  // ── VR subcategories ───────────────────────
  'vr-apple': Apple,
  'vr-meta': Glasses,
  'vr-valve': Glasses,
  'vr-other': Glasses,

  // ── Console subcategories ──────────────────
  'consoles-playstation': Joystick,
  'consoles-xbox': Gamepad2,
  'consoles-nintendo': Gamepad2,
  'consoles-valve': Gamepad2,
  'consoles-other': Gamepad2,
  'console-parts': Wrench,

  // ── AI & Data Centre subcategories ─────────
  'ai-gpu': CircuitBoard,
  'ai-cpu': Cpu,
  'ai-ram': MemoryStick,
  'ai-motherboards': CircuitBoard,
  'ai-storage': HardDrive,
  'ai-pre-built-servers': Server,

  // ── Others subcategories ───────────────────
  'others-audio': Headphones,
  'others-accessories': Keyboard,
  'others-accessories-keyboard': Keyboard,
  'others-business': Briefcase,
  'other-display': Tv,
  'others-display-tv': Tv,
  'others-display-monitor': Monitor,
};

/**
 * Look up the Lucide icon component for a category ID.
 * Falls back to Package (generic box) if no match.
 */
export const getCategoryIcon = categoryId => CATEGORY_ICONS[categoryId] || Package;
